import React from 'react'
import {connect} from 'react-redux'
import styles from './GuidesList.scss'
import {SectionBox} from 'common/styleguide/SectionBox'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {GuidePageListItem} from './GuidePageListItem'
import {createGuidePage, reorderGuidePages} from 'lib/api/experiences/guides'
import {GuidePage as GuidePageRecord} from 'lib/api/records'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd'

export class _GuidesList extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      sectionName: '',
      createPending: false,
      createSuccess: false,
      createError: false
    }
  }

  addSectionTitleChanged = (e) => {
    this.setState({sectionName: e.target.value})
  }

  addSectionClicked = (e) => {
    e.preventDefault()

    const {experience, createGuidePage, setExpanded} = this.props
    const {sectionName} = this.state

    if (!sectionName) return

    this.setState({createPending: true, createSuccess: false, createError: false}, () => {
      createGuidePage(GuidePageRecord({experienceId: experience.id, title: sectionName}))
        .then((r) => {
          setExpanded(r.action.payload.experience_guide_page.id)
          this.setState((state) => ({
            createPending: false,
            createSuccess: true,
            sectionName: ''
          }))
        })
        .catch(() => this.setState({createPending: false, createError: true}))
    })
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const {guideIds, reorderGuidePages, experience} = this.props

    // Move the id from the old position to the new one
    const newIds = Array.from(guideIds)
    const [removed] = newIds.splice(result.source.index, 1)
    newIds.splice(result.destination.index, 0, removed)

    reorderGuidePages(experience.id, newIds)
  }

  render () {
    const {guideIds, guides, expandedId, setExpanded} = this.props
    const {sectionName, createPending} = this.state

    return (
      <div className={styles.GuidesList}>
        <SectionBox title='guide' noPadding className={styles.card}>
          <div className={styles.addSection}>
            Add Section
            <form onSubmit={this.addSectionClicked}>
              <div className={styles.addSectionForm}>
                <div className={styles.input}>
                  <input type='text' placeholder='Enter section header...' onChange={this.addSectionTitleChanged} value={sectionName} />
                </div>
                <div className={styles.button}>
                  <CTA inline secondary margins={false} disabled={createPending} onClick={this.addSectionClicked} className={styles.addSectionButton}>
                    {createPending && <CircleSpinner size={15} className={styles.addSectionSpinner} />}
                    {!createPending && <Icon i='md-add-circle' size={17} className={styles.addSectionIcon} />}
                    Add Section
                  </CTA>
                </div>
              </div>
            </form>
          </div>
          {guideIds &&
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId='droppable'>
                {(provided, snapshot) => (
                  <div ref={provided.innerRef}>
                    {guideIds.map((id, index, a) =>
                      <DraggableGuidePageListItem
                        key={id}
                        id={id}
                        guide={guides.get(id)}
                        index={index}
                        expanded={expandedId === id}
                        setExpanded={setExpanded}
                        hoverDisabled={snapshot.isDraggingOver} />
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          }
        </SectionBox>
      </div>
    )
  }
}

class DraggableGuidePageListItem extends React.PureComponent {
  render () {
    const {index, id, expanded, guide, setExpanded, hoverDisabled} = this.props

    return (
      <Draggable draggableId={`draggableGuidePageListItem-${id}`} isDragDisabled={expanded} index={index}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.draggableProps}>
            <GuidePageListItem
              key={`draggableGP-${guide.id}`}
              setExpanded={setExpanded}
              guide={guide}
              expanded={expanded}
              hoverDisabled={hoverDisabled}
              isDragging={snapshot.isDragging}
              dragHandleProps={provided.dragHandleProps} />
          </div>
        )}
      </Draggable>
    )
  }
}

const mapDispatchToProps = {
  createGuidePage: createGuidePage,
  reorderGuidePages: reorderGuidePages
}

export const GuidesList = connect(
  null,
  mapDispatchToProps
)(_GuidesList)
